import { useRef } from "react";

interface AlertMessageProps {
  title: string;
  body: string;
  btn?: string;
  onShowAlertMessage: any;
  onSetShowAlertMessage: any;
}
const AlertMessage: React.FC<AlertMessageProps> = ({
  title,
  body,
  btn,
  onShowAlertMessage,
  onSetShowAlertMessage,
}) => {
  const closeAlertMessage = (e: any) => {
    if (alertMessageRef.current === e.target || btnMessageRef.current === e.target) {
      onSetShowAlertMessage(false);
      return false;
    }
  };
  const alertMessageRef = useRef<HTMLDivElement>(null);
  const btnMessageRef = useRef<HTMLButtonElement>(null);
  return (
    <div
      className="alert-message"
      id="alert-message"
      onClick={(event) => closeAlertMessage(event)}
      ref={alertMessageRef}
      style={{ maxHeight: `${onShowAlertMessage ? "100%" : "0%"}` }}
    >
      <div
        className="alert-primary__permission"
        style={{ maxHeight: `${onShowAlertMessage ? "100%" : "0%"}` }}
      >
        <h6>{title}</h6>
        <p>{body}</p>
        <div className="alert-primary__btn-gp">
          {btn ? (
            <button
              className="btn btn--primary small u-width-100"
              onClick={(event) => closeAlertMessage(event)}
              ref={btnMessageRef}
            >
              {btn}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AlertMessage;
